// extracted by mini-css-extract-plugin
export default {"paper":"CustomModal_paper__A28Eg","title":"CustomModal_title__HFRFT","closeButton":"CustomModal_closeButton__fdamK","actions":"CustomModal_actions__JDzyP"};